import { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import styles from './reset-filters-link.module.scss';
import ScreenerAppContext from '../../../../stores/screener/screener-app-context';
import { resetFilters } from '../../../../stores/screener/actions/filter-actions';

const className = augmentClassName(styles);

export const ResetFiltersLink = ({ nonDefaultActiveFilters, resetAllFilters }) => {
  const filterLength = nonDefaultActiveFilters.length;
  const { channel } = useContext(ScreenerAppContext);

  if (filterLength === 0) {
    return (
      <span {...className('reset-filters', 'screener-reset-filters')}
        // TIAA Analytics Tracking
        data-analytics-linkname="Reset_filters"
        data-analytics-section="component"
        data-analytics-componenttype="TextLink"
        // END TIAA Analytics Tracking
      >
        <button {...className('reset-link', 'btn-reset')}>Reset filters</button>
      </span>
    );
  }

  return (
    <span {...className('reset-filters', 'screener-reset-filters')}
      // TIAA Analytics Tracking
      data-analytics-linkname="Reset_filters"
      data-analytics-section="component"
      data-analytics-componenttype="TextLink"
      // END TIAA Analytics Tracking
    >
      <button {...className('reset-link')} onClick={() => resetAllFilters(channel)}>Reset filters</button>
      &nbsp;&nbsp;
      <span {...className('active-filter-count')}>({filterLength} active)</span>
    </span>
  );
};

ResetFiltersLink.propTypes = {
  nonDefaultActiveFilters: PropTypes.array.isRequired,
  resetAllFilters: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    nonDefaultActiveFilters: state.filterReducer.nonDefaultActiveFilters
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetAllFilters: channel => dispatch(resetFilters(channel))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetFiltersLink);
